import { get, set, del, entries, delMany } from 'idb-keyval'

import Signal from '../signal'
import { NON_DRAFT_KEYS } from '.'

export type MessageDraft = {
  message: string
  file: File[]
}

const getMessageKey = (userID: string, session: string) =>
  `${userID}__${session}`

// Saves a draft for a specific session and logged in user
export const saveDraft = async (
  userID: string,
  session: string,
  message: MessageDraft
) => {
  try {
    const key = getMessageKey(userID, session)
    await set(key, message)

    // Send signal to code that would need access to this event
    window.SONAR_SIGNAL.signal(Signal.draft, session)
  } catch (err) {
    console.error('Error saving draft', err)
  }
}

// Checks if a draft exists for a specific session and logged in user
export const checkDraft = async (userID: string, session: string) => {
  try {
    const key = getMessageKey(userID, session)
    const val = await get(key)

    if (!val) {
      return null
    }

    return val as MessageDraft
  } catch (err) {
    console.error('Error checking draft', err)
    return null
  }
}

// Gets and deletes a draft for specific session and logged in user
export const pullDraft = async (userID: string, session: string) => {
  try {
    const val = await checkDraft(userID, session)
    const key = getMessageKey(userID, session)
    await del(key)

    // Send signal to code that would need access to this event
    window.SONAR_SIGNAL.signal(Signal.draft, session)

    return val
  } catch (err) {
    console.error('Error pulling draft', err)
    return null
  }
}

// Clears all drafts from indexed db
export const clearAllDrafts = async () => {
  try {
    const allEntries = await entries()
    const toDelete: IDBValidKey[] = []

    allEntries.forEach(entry => {
      const key = entry[0].toString()

      if (NON_DRAFT_KEYS.some(k => key.includes(k))) {
        return
      }

      toDelete.push(key)
    })

    delMany(toDelete).catch(err =>
      console.error('error deleting drafts!!', err)
    )
  } catch (err) {
    console.error('Error clearing db', err)
  }
}
